import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Input, Button } from "arv-reactcomponents";

class BrandListSearch extends Component {
  constructor(props) {
    super(props);

    this.updateQuery = this.updateQuery.bind(this);
    this.handleQuerySubmit = this.handleQuerySubmit.bind(this);
  }

  updateQuery(event) {
    const queryField = event.target.value;
    this.props.handleInputQuery(queryField);
  }

  handleQuerySubmit(event) {
    const { isQueryInputValid } = this.state;
    event.preventDefault();
    this.props.handleInputQuerySubmit(isQueryInputValid);
  }

  render() {
    const {
      query,
      placeholder,
      formClassName,
      inputClassName,
      buttonClassName,
      ...otherProps
    } = this.props;
    return (
      <Fragment>
        <form
          className={formClassName}
          onSubmit={this.handleQuerySubmit}
          autoComplete="off"
        >
          <Input
            className={inputClassName}
            type="text"
            value={query}
            onBlur={this.onBlur}
            onChange={this.updateQuery}
            placeholder={placeholder}
            ref={values => {
              this.validateQueryRef = values;
            }}
            {...otherProps}
          />
          <Button className={buttonClassName} onClick={this.handleSubmit}>
            <i className="icomoon-search3" />
          </Button>
        </form>
      </Fragment>
    );
  }
}

BrandListSearch.defaultProps = {
  formClassName: "",
  inputClassName: "",
  buttonClassName: "",
};

BrandListSearch.propTypes = {
  query: PropTypes.string.isRequired,
  formClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  handleInputQuery: PropTypes.func.isRequired,
  handleInputQuerySubmit: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: BrandListSearch,
  component: BrandListSearch,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/BrandsList/BrandListSearch/index.js